export const parseMaxIncome = (maxIncome = '') => {
  const filteredString = maxIncome.replace(/[^\d]/g, '');

  const formattedIncome = Number(filteredString).toString().substring(0, 10);
  return formattedIncome === '0' ? '' : formattedIncome;
};

export const formatMaxIncome = (maxIncome = '') => {
  const filteredString = maxIncome.replace(/[^\d.]/g, '');

  const [wholeDollars = ''] = filteredString.split('.');

  const formattedIncome = new Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency',
  })
    .format(wholeDollars)
    .replace('$', '');

  return formattedIncome === '0.00' ? '' : formattedIncome;
};
